module.exports = __webpack_public_path__ + "static/img/40.07e018d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/40.png
// module id = 72Xa
// module chunks = 1